/* himedi-lb-home.js: less-busy staging, homepage (2026-10-14). Built by lanes/home/build-assets.py from the approved draft. */
(function () {
  "use strict";
  /* Systems: one menu (rows on desktop, wrapped pills under 900px), one sheet. A swap crossfades the panels, tweens the sheet height from the old panel to the new one (MOTION.md rule 2), crossfades the photo and slides one white pill to the selected row. Retargets cleanly on rapid clicks (rule 3). */
  (function () {
  if (!document.querySelector(".d-sys-list")) return;
  var rows = Array.prototype.slice.call(document.querySelectorAll(".d-sys-row"));
  var bgs = Array.prototype.slice.call(document.querySelectorAll(".d-sys-bgimg"));
  var list = document.querySelector(".d-sys-list");
  var panels = Array.prototype.slice.call(document.querySelectorAll(".d-sys-panel"));
  var sheet = document.querySelector(".d-sys-sheet");
  var reduceMotion = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ind = document.createElement("span");
  ind.className = "d-sys-ind"; ind.setAttribute("aria-hidden", "true");
  list.insertBefore(ind, list.firstChild);
  var cur = Math.max(0, rows.findIndex(function (r) { return r.getAttribute("aria-selected") === "true"; }));
  var heightAnim = null;
  function token(name, fallback) {
    /* Shopify's CDN minifies 280ms to .28s inside the served CSS, so read the unit. */
    var raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    var v = parseFloat(raw);
    if (isNaN(v)) return fallback;
    return /ms$/.test(raw) ? v : /s$/.test(raw) ? v * 1000 : v;
  }
  function placeInd(snap) {
    var r = rows[cur];
    if (snap) ind.style.transition = "none";
    ind.style.height = r.offsetHeight + "px";
    ind.style.transform = "translateY(" + r.offsetTop + "px)";
    if (snap) { void ind.offsetWidth; ind.style.transition = ""; }
  }
  /* Photo stack: bgStack runs bottom to top. A new photo goes on top and fades in over the ones below (held where they are); picking one already in the stack fades out whatever sits above it. When the target has landed the rest are dropped. */
  var bgStack = [cur], bgTarget = cur, bgTimer = null;
  var bgOf = function (i) { return bgs.filter(function (b) { return b.getAttribute("data-sys") === rows[i].getAttribute("aria-controls"); })[0]; };
  var bgLayers = rows.map(function (r, i) { return bgOf(i); });
  bgLayers.forEach(function (b, i) { b.classList.remove("active"); b.style.opacity = i === cur ? "1" : "0"; b.style.zIndex = i === cur ? "1" : "0"; });
  function showBg(i) {
    var dur = reduceMotion ? 150 : 400;
    var pos = bgStack.indexOf(i), tr = "opacity " + dur + "ms cubic-bezier(0.22,1,0.36,1)";
    bgStack.forEach(function (k) { var b = bgLayers[k]; var v = getComputedStyle(b).opacity; b.style.transition = "none"; b.style.opacity = v; });
    if (pos === -1) { bgStack.push(i); bgLayers[i].style.opacity = "0"; }
    bgTarget = i;
    bgStack.forEach(function (k, n) { bgLayers[k].style.zIndex = String(n + 1); });
    void sheet.offsetWidth;
    var t = bgStack.indexOf(i);
    bgStack.forEach(function (k, n) {
      var b = bgLayers[k];
      if (n === t) { b.style.transition = tr; b.style.opacity = "1"; }
      else if (n > t) { b.style.transition = tr; b.style.opacity = "0"; }
    });
    clearTimeout(bgTimer);
    bgTimer = setTimeout(function () {
      if (bgTarget !== i) return;
      bgStack.forEach(function (k) { if (k !== i) { bgLayers[k].style.transition = "none"; bgLayers[k].style.opacity = "0"; bgLayers[k].style.zIndex = "0"; } });
      bgStack = [i]; bgLayers[i].style.zIndex = "1";
    }, dur + 30);
  }
  function pick(i, focus) {
    if (i === cur) { if (focus) rows[i].focus({ preventScroll: true }); return; }
    var from = sheet.getBoundingClientRect().height;
    if (heightAnim && heightAnim.cancel) heightAnim.cancel();
    heightAnim = null;
    cur = i;
    rows.forEach(function (r, k) {
      var on = k === i;
      r.setAttribute("aria-selected", on ? "true" : "false");
      r.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (p, k) { p.classList.toggle("is-active", k === i); });
    var to = sheet.getBoundingClientRect().height;
    if (!reduceMotion && Math.abs(to - from) > 0.5) {
      var a = sheet.animate([{ height: from + "px" }, { height: to + "px" }], { duration: token("--dur-swap", 280), easing: "cubic-bezier(0.77,0,0.175,1)" });
      heightAnim = a;
      a.onfinish = a.oncancel = function () { if (heightAnim === a) heightAnim = null; };
    }
    showBg(i);
    placeInd(false);
    if (focus) rows[i].focus({ preventScroll: true });
  }
  rows.forEach(function (r, i) {
    r.addEventListener("click", function () { pick(i, false); });
    r.addEventListener("keydown", function (e) {
      var n = null;
      if (e.key === "ArrowDown" || e.key === "ArrowRight") n = (i + 1) % rows.length;
      else if (e.key === "ArrowUp" || e.key === "ArrowLeft") n = (i - 1 + rows.length) % rows.length;
      else if (e.key === "Home") n = 0;
      else if (e.key === "End") n = rows.length - 1;
      if (n !== null) { e.preventDefault(); pick(n, true); }
    });
  });
  placeInd(true);
  window.addEventListener("resize", function () { placeInd(true); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { placeInd(true); });

  })();

  /* Scroll reveal (MOTION.md rule 6): once, top past 85% of the viewport, siblings entering together stagger 60ms. */
  (function () {
    var els = Array.prototype.slice.call(document.querySelectorAll([".d-why .d-head",".d-why-card",".d-sys-intro",".d-sys-list",".d-sys-sheet",".d-cmp-copy",".cmp",".out .d-head",".d-quote",".d-feat","section.final .wrap"].join(",")));
    if (!els.length || !("IntersectionObserver" in window)) return;
    document.documentElement.classList.add("d-rv-on");
    els.forEach(function (e) { e.classList.add("d-rv"); });
    var io = new IntersectionObserver(function (entries) {
      var n = new Map();
      entries.forEach(function (en) {
        if (!(en.isIntersecting || en.boundingClientRect.top < 0)) return;
        var t = en.target, p = t.parentElement, k = n.get(p) || 0;
        n.set(p, k + 1);
        t.style.setProperty("--rv-d", Math.min(k, 4) * 60 + "ms");
        t.classList.add("d-in");
        io.unobserve(t);
        setTimeout(function () { t.classList.add("d-done"); }, 700 + Math.min(k, 4) * 60);
      });
    }, { rootMargin: "0px 0px -15% 0px", threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* Why cards: live's draw-in runs from CSS view() timelines. Where the browser has none, set the same two numbers from scroll position. */
  var whyCards = Array.prototype.slice.call(document.querySelectorAll(".d-why-card"));
  var noView = !(window.CSS && CSS.supports && CSS.supports("animation-timeline", "view()"));
  var still = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (whyCards.length && noView && !still) {
    var clamp01 = function (x) { return Math.max(0, Math.min(1, x)); };
    var ticking = false;
    var updWhy = function () {
      ticking = false;
      var vh = window.innerHeight;
      whyCards.forEach(function (c) {
        var r = c.getBoundingClientRect(), h = r.height;
        var from = vh - 0.4 * h, to = vh / 2 - h / 2;          /* entry 40% -> centred */
        c.style.setProperty("--whyb-p", clamp01((from - r.top) / (from - to)).toFixed(3));
        c.style.setProperty("--whyb-q", clamp01((vh - r.top) / (vh + h)).toFixed(3));
      });
    };
    var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(updWhy); } };
    window.addEventListener("scroll", queue, { passive: true });
    window.addEventListener("resize", queue);
    updWhy();
  }

})();

/* lead session 2026-10-14: the section keeps one size; only the info card resizes inside it.
   The grid reserves room for the tallest system (its card's top + the tallest card). */
(function(){
  var grid=document.querySelector('.d-sys-grid'), sheet=document.querySelector('.d-sys-sheet');
  if(!grid||!sheet) return;
  var panels=[].slice.call(sheet.querySelectorAll('.d-sys-panel'));
  function reserve(){
    grid.style.minHeight='';
    var active=sheet.querySelector('.d-sys-panel.is-active')||panels[0];
    var chrome=sheet.offsetHeight-active.offsetHeight;
    var tallest=0; panels.forEach(function(p){ tallest=Math.max(tallest,p.offsetHeight); });
    var top=sheet.getBoundingClientRect().top-grid.getBoundingClientRect().top;
    var need=Math.ceil(Math.max(grid.offsetHeight, top+chrome+tallest));
    grid.style.minHeight=need+'px';
  }
  var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(reserve,120); });
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(reserve);
  window.addEventListener('load',reserve); reserve();
})();
